import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  form: {
    width: 990
  },
  title: {
    fontSize: '1.2em',
    paddingBottom: 15
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addzoneform/zonepreview/ZonePreview.styles.js